import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaSearch, FaEnvelope, FaStar } from 'react-icons/fa';

const Hero = () => {
    return (
        <div className="hero-section">
            <Container>
                <Row className="align-items-center">
                    <Col lg={8} className="text-center text-lg-start">
                        <h1 className="hero-title">Agenti</h1>
                        <p className="hero-subtitle px-3 px-lg-0">
                            Your daily quest for the most delightful AI tools and agents begins here.
                        </p>
                        <div className="hero-features">
                            <div className="feature">
                                <FaSearch className="feature-icon" />
                                <span className="feature-text">Discover AI Tools</span>
                            </div>
                            <div className="feature">
                                <FaEnvelope className="feature-icon" />
                                <span className="feature-text">Daily Newsletter</span>
                            </div>
                            <div className="feature">
                                <FaStar className="feature-icon" />
                                <span className="feature-text">Curated Picks</span>
                            </div>
                        </div>
                    </Col>
                    <Col lg={4} className="d-none d-lg-block">
                        <div className="hero-image-container">
                            {/* <img 
                                src="/ai-illustration.png" 
                                alt="AI Illustration" 
                                className="hero-image"
                            /> */}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Hero; 